import { MapProperty } from 'cadenza/map/map-property';
import { MultiActionButton } from 'ui/multi-action-button/multi-action-button';
import { cadenzaSessionStorage } from 'cadenza/utils/session-storage/session-storage';
export const TOOLBAR_STATE_KEY = 'map.toolbar.autoactivate';

// TODO maybe use a dedicated class for items that need to stay enabled → check when we have the next use case of the side panel
const DEFAULT_NON_DISABLEABLE_BUTTON_SELECTORS = [
  '.d-gazetteer-providers-button',
  '.d-gazetteer-clear-button',
  '.d-gazetteer-back-button',
  '#map-action--zoom-out',
  '#map-action--zoom-in',
  '#map-action--zoom-to-extent',
  '#map-action--undo',
  '#map-action--redo',
  '#more-actions' ];

/**
 * Disables selected buttons
 *
 * @param { boolean } disabled - if the buttons have to be disabled of enabled
 * @param {object} options
 * @param {string[]} options.nonDisableableButtonSelectors - css selectors for the buttons, which shouldn't be disabled. There is also a default list of button selectors, which should never be disabled by this function, see DEFAULT_NON_DISABLEABLE_BUTTON_SELECTORS.
 */
export function disableToolbarButtons (disabled, { nonDisableableButtonSelectors = [] } = {}) {
  // maybe the list to disable will be passed from outside when this function is used from more places

  const allIgnoreButtonSelectors = [ ...DEFAULT_NON_DISABLEABLE_BUTTON_SELECTORS, ...nonDisableableButtonSelectors ];
  const mapContainer = document.querySelector('.mapContainer');
  const mapToolbar = mapContainer?.querySelector('.d-legacy-map-toolbar');
  const buttons = mapToolbar?.querySelectorAll('.button, .d-multi-action-button');
  if (buttons) {
    const toolbarButtons = Array.from(buttons);
    toolbarButtons
      .filter(button => !allIgnoreButtonSelectors.some(selector => button.matches(selector)))
      .forEach(button => {
        if (disabled && !button.disabled) {
          button.disabled = true;
          button.dataset.forceDisabled = 'true'; // to later know which buttons need to be enabled back (some may already been disabled before)
        } else if (button.dataset.forceDisabled) {
          button.disabled = false;
        }
      });
  }
  // set flag on moreActionsButton on toolbar, which when there is no space for a button shows button as an action
  const moreActionsButton = mapToolbar?.querySelector('.more-actions');
  if (moreActionsButton) {
    moreActionsButton.dataset.sidePanelIsOpen = Boolean(disabled).toString();
  }
}

// TODO (palys) we may remove this class when we have on implementation of toolbar (toolbar.js and map-toolbar.js)
// this is only a DRY
export function onPrimaryInteractionChanged (map, interactionActionToButtonOrDropdown, oldInteraction) {
  const interaction = map.get(MapProperty.PRIMARY_INTERACTION);
  const oldInteractionAction = Array.from(interactionActionToButtonOrDropdown.keys()).find(action => action.interactionClass && oldInteraction instanceof action.interactionClass);
  const newInteractionAction = Array.from(interactionActionToButtonOrDropdown.keys()).find(action => action.interactionClass && interaction instanceof action.interactionClass);

  const oldInteractionActionButton = interactionActionToButtonOrDropdown.get(oldInteractionAction);
  const newInteractionActionButton = interactionActionToButtonOrDropdown.get(newInteractionAction);

  updateButtonsState(oldInteractionActionButton, newInteractionActionButton, newInteractionAction);

  if (newInteractionAction && newInteractionAction.persistInteractionToSession) {
    cadenzaSessionStorage.setItem(TOOLBAR_STATE_KEY, newInteractionAction.interactionName);
  } else {
    cadenzaSessionStorage.removeItem(TOOLBAR_STATE_KEY);
  }
}

function updateButtonsState (oldBtn, newBtn, newAction) {
  if (newBtn && oldBtn === newBtn) {
    newBtn.updateCurrentAction(newAction);
    newBtn.pressed = true;
  } else {
    if (oldBtn) {
      if (oldBtn instanceof MultiActionButton) {
        oldBtn.pressed = false;
      } else {
        oldBtn.setAttribute('aria-pressed', false);
      }
    }

    if (newBtn) {
      if (newBtn instanceof MultiActionButton) {
        newBtn.updateCurrentAction(newAction);
        newBtn.pressed = true;
      } else {
        newBtn.setAttribute('aria-pressed', true);
      }
    }
  }
}

